import React from 'react';
import { AlertTriangleIcon, ClockIcon, FileSignatureIcon, InboxIcon, MapIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';
import { dispatchFeatures } from '../data/content';
import { Reveal } from './showcase/Reveal';
import { AgreementVignette } from './showcase/AgreementVignette';
const icons = {
  map: MapIcon,
  clock: ClockIcon,
  alert: AlertTriangleIcon,
  users: UsersIcon,
  shield: ShieldCheckIcon,
  inbox: InboxIcon,
  signature: FileSignatureIcon
};
interface DispatchBrainProps {
  eyebrow?: string;
  title?: string;
  showAgreement?: boolean;
}
export function DispatchBrain({
  eyebrow = 'Inside the system',
  title = 'Not an answering machine. A dispatch brain for your team.',
  showAgreement = false
}: DispatchBrainProps) {
  return <section id="dispatch" aria-labelledby="dispatch-title" className="border-b border-white/5 bg-ink-900" data-id="element-70" data-mp="1a3nkgeemdcw2">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-71" data-mp="155m07q5gj7j0">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-72" data-mp="1y6gvd5wjqmqn">
          {eyebrow}
        </p>
        <h2 id="dispatch-title" className="mt-5 max-w-2xl font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl" data-id="element-73" data-mp="234iefqtz2m24">
          {title}
        </h2>

        <div className="mt-12 grid gap-px overflow-hidden rounded-xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-74" data-mp="2c71e622goik5">
          {dispatchFeatures.map((feature, index) => {
          const Icon = icons[feature.icon];
          return <Reveal key={feature.title} delay={0.06 * index} offset={12} className="h-full" data-id="element-75" data-mp="2quuszkjq3h1o" data-mpi={index}>
                <div className="h-full bg-ink-800 p-7" data-id="element-76" data-mp="2uvoksp0adfzu">
                  <Icon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-77" data-mp="2zwc932x4riqd" />
                  <h3 className="mt-5 font-display text-lg font-semibold tracking-tight text-white" data-id="element-78" data-mp="34ue14dcjasdz">
                    {feature.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-79" data-mp="14snvt4q8nhr4">
                    {feature.body}
                  </p>
                </div>
              </Reveal>;
        })}
        </div>

        {showAgreement && <div className="mt-12 grid gap-8 lg:grid-cols-2 lg:items-center lg:gap-14" data-id="element-80" data-mp="19qz77jw6m0bg">
            <Reveal delay={0.05} data-id="element-81" data-mp="1nivyxmtxu87b">
              <AgreementVignette data-id="element-82" data-mp="1nhuljbpg99mf" />
            </Reveal>
            <Reveal delay={0.12} data-id="element-83" data-mp="1jhanm5x1y1z8">
              <h3 className="max-w-md font-display text-xl font-semibold tracking-tight text-white" data-id="element-84" data-mp="1ji274iddk995">
                Tour agreements, handled.
              </h3>
              <p className="mt-3 max-w-md text-sm leading-relaxed text-white/60" data-id="element-85" data-mp="1xepelf2yehtb">
                Sent the moment the tour is booked, reminded until it is signed. Your
                brokerage&rsquo;s form, your broker&rsquo;s language.
              </p>
            </Reveal>
          </div>}
      </div>
    </section>;
}